import React from 'react';
import { Color, Text, Preset } from '@lux/text';
import { Translate } from '@pegasus/translation';
import * as S from './MainCategoryList.styles';
export var MainCategoryList = function (_a) {
    var selectedPath = _a.selectedPath, allCategoriesForCampaign = _a.allCategoriesForCampaign, selectedCategoriesSet = _a.selectedCategoriesSet, availableCategoriesSet = _a.availableCategoriesSet, toggleSelection = _a.toggleSelection;
    var categories = (allCategoriesForCampaign === null || allCategoriesForCampaign === void 0 ? void 0 : allCategoriesForCampaign.categories) || [];
    return (React.createElement(S.List, null, categories.map(function (category) {
        var isAvailable = availableCategoriesSet.has(category.id);
        var isSelected = selectedCategoriesSet.has(category.id);
        var isActive = selectedPath.includes(category.id);
        var onSelectAllClick = function () {
            if (!isSelected) {
                toggleSelection(category.id, 1);
            }
        };
        var onClick = function () {
            if (!isActive) {
                toggleSelection(category.id, 1);
            }
        };
        return (React.createElement("li", { key: category.id, "aria-label": category.name },
            React.createElement(S.StyledButton, { onClick: onClick, type: "button", "aria-pressed": isActive || categories.length === 1 },
                React.createElement(Text, { bold: true, color: isActive || categories.length === 1 ? Color.primary : Color.dark, preset: Preset.M, uppercase: true }, category.name)),
            (isActive || categories.length === 1) && (React.createElement(S.SelectAllButton, { onClick: onSelectAllClick, type: "button", "aria-pressed": isSelected || (!selectedPath.length && categories.length === 1) },
                React.createElement(Text, { color: isSelected ||
                        (!selectedPath.length && categories.length === 1)
                        ? Color.primary
                        : Color.dark, preset: Preset.S, disabled: !isAvailable },
                    React.createElement(Translate, { message: "filters.allIn", params: { category: category.name } }))))));
    })));
};
export default MainCategoryList;
